export default __webpack_public_path__ + "static/media/toggle.ec26c09e.svg";